"use client";

import { usePasswordReset } from "@/context/passwordReset";

import LookupForm from "@/components/lookup/form";

export default function VerifyForm() {
  const { errors, passwordResetUser, setErrors, setPasswordResetUser } =
    usePasswordReset();

  return (
    <LookupForm
      entity={passwordResetUser}
      errors={errors}
      set={setPasswordResetUser}
      setErrors={setErrors}
      title="Verify Your Account"
    />
  );
}
